import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Invoice from "src/layouts/AdminPortal/Subscriptions/Invoice";
import ReactDOM from "react-dom/client";

export const exportInvoiceAsPDF = async (invoiceData: any) => {
  // Step 1: Create hidden container

  const A4_WIDTH_PX = 794;
  const A4_HEIGHT_PX = 1123;
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.left = "-10000px";
  container.style.top = "0";
  container.style.width = `${A4_WIDTH_PX}px`;
container.style.height = `${A4_HEIGHT_PX}px`;
  container.style.maxWidth = "210mm";
  container.style.maxHeight = "297mm";
  container.style.overflow = "hidden";
  container.style.transform = "scale(1)";
  container.style.padding = "0";
  container.style.margin = "0";
  container.style.border = "none";
  container.style.backgroundColor = "white"; // Ensure white background
  container.style.overflow = "hidden";
  document.body.appendChild(container);

  // Step 2: Render invoice into the container
  const root = ReactDOM.createRoot(container);
  root.render(<Invoice data={invoiceData} />);

  await new Promise(res => setTimeout(res, 500));

  // Step 3: Create canvas from rendered content
  const canvas = await html2canvas(container, {
    useCORS: true,
    scale: 2, // not recognized by the type, but valid at runtime
    backgroundColor: null,
    scrollY: -window.scrollY,
  } as any);

  // Step 4: Convert canvas to image and generate PDF
  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const pxToMm = (px: number) => (px * 25.4) / 96;
  const imgWidthMm = pxToMm(canvas.width);
  const imgHeightMm = pxToMm(canvas.height);

  const ratio = Math.min(pdfWidth / imgWidthMm, pdfHeight / imgHeightMm);
  const finalWidth = imgWidthMm * ratio;
  const finalHeight = imgHeightMm * ratio;

  const xOffset = (pdfWidth - finalWidth) / 2;
  const yOffset = (pdfHeight - finalHeight) / 2;

  pdf.addImage(imgData, "PNG", 0, 0, 210, 297); // Fill entire A4 page
  // pdf.addImage(imgData, "PNG", xOffset, yOffset, finalWidth, finalHeight);
  pdf.save(`Invoice-${invoiceData.invoice_number || "Export"}.pdf`);

  // Cleanup
  root.unmount();
  document.body.removeChild(container);
};
